/* GO HOME · Rediseño oct 2026 · Santiago Pérez
   Botón "Agregar" de los complementos del carrito (drawer y página /cart).
   Usa /cart/add.js y, si existe el drawer de Ride, lo vuelve a pintar con renderContents().
   El listener es delegado porque el drawer reemplaza su HTML en cada cambio. */
(function () {
  if (window.ghCarritoListo) return;
  window.ghCarritoListo = true;

  document.addEventListener('click', function (event) {
    var boton = event.target.closest('[data-gh-add]');
    if (!boton) return;
    event.preventDefault();

    var drawer = document.querySelector('cart-drawer');
    var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var cuerpo = { items: [{ id: Number(boton.getAttribute('data-gh-add')), quantity: 1 }] };
    if (drawer && typeof drawer.renderContents === 'function') {
      cuerpo.sections = ['cart-drawer', 'cart-icon-bubble'];
      cuerpo.sections_url = window.location.pathname;
    }

    var textoOriginal = boton.textContent;
    boton.disabled = true;
    boton.textContent = 'Agregando…';

    fetch(raiz + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(cuerpo)
    })
      .then(function (r) { return r.json(); })
      .then(function (estado) {
        if (estado.status) {
          boton.textContent = 'Sin stock';
          return;
        }
        if (cuerpo.sections && estado.sections) {
          drawer.renderContents(estado);
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        boton.disabled = false;
        boton.textContent = textoOriginal;
      });
  });
})();
